import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { UNINITIALIZED, REGISTER_SMS, CHANGE_SECURITY_NUMBER, VERIFY_SMS, VERIFICATION_SUCCESSFUL } from '../../constants/security/SecurityPhoneNumberSetupSteps';
import { getSetupStep } from '../../selectors/security/SecurityPhoneNumberSetupSelector';
import SecurityPhoneNumberRecord from '../../records/security/SecurityPhoneNumber';
import { getSecurityPhoneNumber, getCanModifySecurityPhoneNumber } from '../../selectors/security/SecurityPhoneNumberSelector';
import SecurityPhoneNumber from '../../components/security/SecurityPhoneNumber';
import SecurityPhoneNumberSetup from '../../components/security/SecurityPhoneNumberSetup';
import { setup, fetchConfiguration } from '../../actions/security/SecurityPhoneNumberActions';
import { toggleDeleteTrustedNumberModal, toggleUpdateTrustedNumberModal } from '../../actions/AppActions';
import { getEmailFromAuth } from '../../selectors/AuthSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class SecurityPhoneNumberContainer extends Component {
  componentDidMount() {
    this.props.fetchConfiguration();
  }
  shouldShowSetup() {
    return this.props.step !== UNINITIALIZED;
  }
  render() {
    const {
      securityPhoneNumber,
      email,
      canModify
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(SecurityPhoneNumber, {
        onSetup: this.props.setup,
        securityPhoneNumber: securityPhoneNumber,
        email: email,
        toggleDeleteTrustedNumberModal: this.props.toggleDeleteTrustedNumberModal,
        toggleUpdateTrustedNumberModal: this.props.toggleUpdateTrustedNumberModal,
        readOnly: !canModify
      }), this.shouldShowSetup() && /*#__PURE__*/_jsx(SecurityPhoneNumberSetup, {})]
    });
  }
}
SecurityPhoneNumberContainer.propTypes = {
  step: PropTypes.oneOf([UNINITIALIZED, REGISTER_SMS, CHANGE_SECURITY_NUMBER, VERIFY_SMS, VERIFICATION_SUCCESSFUL]).isRequired,
  securityPhoneNumber: PropTypes.instanceOf(SecurityPhoneNumberRecord).isRequired,
  email: PropTypes.string.isRequired,
  setup: PropTypes.func.isRequired,
  fetchConfiguration: PropTypes.func.isRequired,
  toggleDeleteTrustedNumberModal: PropTypes.func.isRequired,
  toggleUpdateTrustedNumberModal: PropTypes.func.isRequired,
  canModify: PropTypes.bool.isRequired
};
function mapStateToProps(state) {
  return {
    step: getSetupStep(state),
    securityPhoneNumber: getSecurityPhoneNumber(state),
    email: getEmailFromAuth(state),
    canModify: getCanModifySecurityPhoneNumber(state)
  };
}
export default connect(mapStateToProps, {
  setup,
  fetchConfiguration,
  toggleDeleteTrustedNumberModal,
  toggleUpdateTrustedNumberModal
})(SecurityPhoneNumberContainer);